import { render, staticRenderFns } from "./LayoutIndexRightFooter.vue?vue&type=template&id=3a55da22&scoped=true&"
import script from "./LayoutIndexRightFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutIndexRightFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutIndexRightFooter.vue?vue&type=style&index=0&id=3a55da22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a55da22",
  null
  
)

export default component.exports